class SkinsService {
  static weaponIds = {
    "weapon_deagle": 1,
    "weapon_elite": 2,
    "weapon_fiveseven": 3,
    "weapon_glock": 4,
    "weapon_ak47": 7,
    "weapon_aug": 8,
    "weapon_awp": 9,
    "weapon_famas": 10,
    "weapon_g3sg1": 11,
    "weapon_galilar": 13,
    "weapon_m249": 14,
    "weapon_m4a1": 16,
    "weapon_mac10": 17,
    "weapon_p90": 19,
    "weapon_mp5sd": 23,
    "weapon_ump45": 24,
    "weapon_xm1014": 25,
    "weapon_bizon": 26,
    "weapon_mag7": 27,
    "weapon_negev": 28,
    "weapon_sawedoff": 29,
    "weapon_tec9": 30,
    "weapon_taser": 31,
    "weapon_hkp2000": 32,
    "weapon_mp7": 33,
    "weapon_mp9": 34,
    "weapon_nova": 35,
    "weapon_p250": 36,
    "weapon_shield": 37,
    "weapon_scar20": 38,
    "weapon_sg556": 39,
    "weapon_ssg08": 40,
    "weapon_knifegg": 41,
    "weapon_knife": 42,
    "weapon_flashbang": 43,
    "weapon_hegrenade": 44,
    "weapon_smokegrenade": 45,
    "weapon_molotov": 46,
    "weapon_decoy": 47,
    "weapon_incgrenade": 48,
    "weapon_c4": 49,
    "weapon_healthshot": 57,
    "weapon_knife_t": 59,
    "weapon_m4a1_silencer": 60,
    "weapon_usp_silencer": 61,
    "weapon_cz75a": 63,
    "weapon_revolver": 64,
    "weapon_tagrenade": 68,
    "weapon_fists": 69,
    "weapon_breachcharge": 70,
    "weapon_tablet": 72,
    "weapon_melee": 74,
    "weapon_axe": 75,
    "weapon_hammer": 76,
    "weapon_spanner": 78,
    "weapon_knife_ghost": 80,
    "weapon_firebomb": 81,
    "weapon_diversion": 82,
    "weapon_frag_grenade": 83,
    "weapon_snowball": 84,
    "weapon_bumpmine": 85,
    "weapon_bayonet": 500,
    "weapon_knife_css": 503,
    "weapon_knife_flip": 505,
    "weapon_knife_gut": 506,
    "weapon_knife_karambit": 507,
    "weapon_knife_m9_bayonet": 508,
    "weapon_knife_tactical": 509,
    "weapon_knife_falchion": 512,
    "weapon_knife_survival_bowie": 514,
    "weapon_knife_butterfly": 515,
    "weapon_knife_push": 516,
    "weapon_knife_cord": 517,
    "weapon_knife_canis": 518,
    "weapon_knife_ursus": 519,
    "weapon_knife_gypsy_jackknife": 520,
    "weapon_knife_outdoor": 521,
    "weapon_knife_stiletto": 522,
    "weapon_knife_widowmaker": 523,
    "weapon_knife_skeleton": 525,
    "weapon_knife_kukri": 526,
    "studded_brokenfang_gloves": 4725,
    "studded_bloodhound_gloves": 5027,
    "t_gloves": 5028,
    "ct_gloves": 5029,
    "sporty_gloves": 5030,
    "slick_gloves": 5031,
    "leather_handwraps": 5032,
    "motorcycle_gloves": 5033,
    "specialist_gloves": 5034,
    "studded_hydra_gloves": 5035
  }


  isKnife(weaponDefindex) {
    // Glove weapon_defindexes - these are the known glove IDs
    const gloveDefindexes = [
        5027, // studded_bloodhound_gloves
        5030, // sporty_gloves
        5031, // slick_gloves
        5032, // leather_handwraps
        5033, // motorcycle_gloves
        5034, // specialist_gloves
        5035, // studded_hydra_gloves
        4725  // studded_brokenfang_gloves
    ];
    
    const weaponDefindexInt = parseInt(weaponDefindex);
    
    // Check if it's a glove
    if (gloveDefindexes.includes(weaponDefindexInt)) {
        return false;
    }
    
    // Regular weapons (defindex < 500) are not knives
    if (weaponDefindexInt < 500) {
        return false;
    }
    
    // For defindex >= 500, check if it's a knife
    // Knives have defindex >= 500 but are not in the glove list
    // This includes: 500 (bayonet), 503-526 (various knives)
    return !gloveDefindexes.includes(weaponDefindexInt);
  }

  constructor(http, steamid) {
    this.http = http;
    this.steamid = steamid;
    this.token = "1234567890"
  }

  async getSkins() {
    return this.http.get(`skinsapi`);
  }

  // PUT /api/player/:steamId/skins - Update or create skin
  // addWeaponSkinPaint(this.currentSkin.weapon.id, this.currentSkin.paint_index, this.form.team, this.form.float, this.currentSkin.weapon.weapon_id)
  async addWeaponSkinPaint(weaponName, paintIndex, team, float = 0.06, weapon_defindex = 0, weapon_seed = 0, stattrak = false) {
    return this.http.put(`skinsapi/skins`, {
      weaponId: SkinsService.weaponIds[weaponName],
      paintId: paintIndex,
      team: team,
      float: float,
      weaponName: weapon_defindex,
      weaponSeed: weapon_seed,
      // stattrak: stattrak,
    });
  }


  // DELETE /api/player/:steamId/knife - Delete knife
  async deleteKnife(knifeName, team = 0) {
    return this.http.delete(`skinsapi/knife?team=${team}&knifeId=${knifeName}`);
  }

  async deleteSkinPaint(weaponName, paintIndex) {
    //
    // console.log(weaponName, paintIndex, SkinsService.weaponIds)

    const foundWeapon = SkinsService.weaponIds[weaponName]

    return this.http.delete(`skinsapi/skins/${foundWeapon}/paint/${paintIndex}`);
  }
  
}

export default SkinsService;